module.exports = __webpack_public_path__ + "media/images/golden_pin_concept_award_logo-b724760ec0ba2ef33091df0cc0b80b1d.png";